import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  listDeploymentsApi,
  listKnowledgeBasesApi,
  createDeploymentApi,
  type AgentDeployment,
  type ResourceVersion,
} from "@/lib/api";

export function useKnowledgeBases(clientId: string | undefined) {
  return useQuery<ResourceVersion[]>({
    queryKey: ["super-admin", "knowledge-bases", clientId],
    queryFn: () => listKnowledgeBasesApi(clientId!),
    enabled: !!clientId,
  });
}

export function useDeployments(clientId: string | undefined) {
  return useQuery({
    queryKey: ["super-admin", "deployments", clientId],
    queryFn: () => listDeploymentsApi(clientId!),
    enabled: !!clientId,
  });
}

export function useCreateDeployment(clientId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Parameters<typeof createDeploymentApi>[1]) =>
      createDeploymentApi(clientId, data),
    onSuccess: (d: AgentDeployment) => {
      void qc.invalidateQueries({ queryKey: ["super-admin", "deployments", d.clientId] });
    },
  });
}
